export { default } from "./FaqArticlesList";
